import {
  MUTATION_RESPONSE_RECEIVED,
  QUERY_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import { LOYALTY_DISCOUNTS } from '@web-platform/shared-universal-types/src/network/requestTypes';

import type {
  MutationAction,
  MutationResponseAction,
  QueryAction,
  QueryResponseAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  LoyaltyDiscountsItinerariesBookingPanel,
  LoyaltyDiscountsStateBookingPanel,
  LoyaltyPricingOptionBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/loyaltyDiscountsBookingPanel';

export const INITIAL_STATE: LoyaltyDiscountsStateBookingPanel = { itineraries: { byId: {} } };

const byId = (
  state: LoyaltyDiscountsItinerariesBookingPanel,
  action: QueryResponseAction | MutationResponseAction,
): LoyaltyDiscountsItinerariesBookingPanel => {
  switch (action.payload.type) {
    case LOYALTY_DISCOUNTS: {
      const { response } = action.payload;

      // @ts-expect-error -- GREYF-135 will update this reducer to read the new FetchResponse shape
      if (!response.headers || !response.body?.itineraryId || !response.body?.pricingOptions) {
        return state;
      }

      // @ts-expect-error -- GREYF-135 will update this reducer to read the new FetchResponse shape
      const { itineraryId, pricingOptions: newPricingOptions } = response.body;

      const oldPricingOptions = (state[itineraryId]?.pricingOptions || []).filter(
        (existingOption) =>
          !newPricingOptions.some(
            // @ts-expect-error -- GREYF-135 will update this reducer to read the new FetchResponse shape
            (newOption) => newOption.pricingOptionId === existingOption.pricingOptionId,
          ),
      );

      const transformPricingOptions: LoyaltyPricingOptionBookingPanel[] = newPricingOptions.map(
        // @ts-expect-error -- GREYF-135 will update this reducer to read the new FetchResponse shape
        (pricingOption) => ({
          pricingOptionId: pricingOption.pricingOptionId || '',
          decryptedAgoraToken: {
            originalPrice: pricingOption.decryptedAgoraToken?.originalPrice ?? 0,
            discountAmount: pricingOption.decryptedAgoraToken?.discountAmount ?? 0,
          },
        }),
      );

      return {
        ...state,
        [itineraryId]: {
          itineraryId,
          pricingOptions: [...oldPricingOptions, ...transformPricingOptions],
        },
      };
    }

    default:
      return state;
  }
};

const loyaltyDiscountsReducer = (
  state: LoyaltyDiscountsStateBookingPanel = INITIAL_STATE,
  action: MutationAction | QueryAction,
): LoyaltyDiscountsStateBookingPanel => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      return {
        itineraries: {
          byId: byId(state.itineraries.byId, action),
        },
      };
    }
    default:
      return state;
  }
};

export default loyaltyDiscountsReducer;
